import { FC, PropsWithChildren, useState } from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import Spinner from '../spinner/Spinner';

interface Props {
  title?: string;
  header?: string;
  value: string;
  isLoading?: boolean;
  icon?: JSX.Element;
  onClick?: () => void;
  moreDetails?: string;
  className?: string;
}

const Card: FC<PropsWithChildren<Props>> = ({
  title,
  header,
  value,
  icon,
  onClick,
  isLoading,
  moreDetails,
  className,
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleInfoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsTooltipVisible(prev => !prev);
  };

  const handleMouseEnter = () => setIsTooltipVisible(true);
  const handleMouseLeave = () => setIsTooltipVisible(false);

  return (
    <div
      onClick={onClick}
      className={`relative flex flex-col gap-3 p-3  border border-gray-200 primary-shadow cursor-pointer bg-white ${
        className || ''
      }`}
    >
      {/* Icon + Header */}
      <div className='flex justify-between items-center text-nowrap'>
        <div className='flex items-center gap-3'>
          <span className='w-10 h-10 flex items-center justify-center bg-primaryBg-100 rounded-full'>
            {icon}
          </span>
          <p className='text-gray-600 font-medium text-lg'>{header}</p>
        </div>

        {moreDetails && (
          <div
            className='relative group inline-block'
            onClick={handleInfoClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <BsInfoCircle color='#1133BB' size={22} className='mt-1' />
            {isTooltipVisible && (
              <div className='hidden group-hover:block absolute top-full right-0 mt-2 w-60 bg-white border border-gray-300 rounded-md shadow-md z-10 p-2'>
                <p className='text-sm  whitespace-normal'>{moreDetails}</p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Value and Title */}
      <div>
        {isLoading ? (
          <Spinner />
        ) : (
          <p className='text-2xl font-semibold'>{value}</p>
        )}
        <p className='text-sm font-medium text-gray-500 mt-1'>{title}</p>
      </div>
    </div>
  );
};

export default Card;
